import GetSafetyAnchorPointsBySiHaDocumentationRequestModelBase from '../_generated/modelBases/get-safety-anchor-points-by-si-ha-documentation-request-model-base';

export default class GetSafetyAnchorPointsBySiHaDocumentationRequestModel extends GetSafetyAnchorPointsBySiHaDocumentationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
